/* unplugin-vue-components disabled */import { render } from "./Customize.vue?vue&type=template&id=6cc4bbf6&scoped=true"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"

import "./Customize.vue?vue&type=style&index=0&id=6cc4bbf6&scoped=true&lang=css"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc4bbf6"]])

export default __exports__